module.exports = __webpack_public_path__ + "img/03.49a7ee83.png";